import { render } from "./index.vue?vue&type=template&id=5cc64709&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=5cc64709&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5cc64709"],['__file',"src/views/SignUpMFA/components/step2/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5cc64709"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5cc64709', __exports__)) {
    api.reload('5cc64709', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=5cc64709&scoped=true", () => {
    api.rerender('5cc64709', render)
  })

}


export default __exports__